import React from 'react';
import { MasteringContainer } from './Mastering.style';
import HeadingWithIcon from './HeadingWithIcon';
// Images
import CivicsLogo from "../../Assets/Images/LandingPage/civics_logo.png";
import EnglishLogo from "../../Assets/Images/LandingPage/english_logo.png";
import HistoryLogo from "../../Assets/Images/LandingPage/history_logo.png";
import MathLogo from "../../Assets/Images/LandingPage/math_logo.png";
import ScienceLogo from "../../Assets/Images/LandingPage/science_logo.png";
import EconomicsLogo from "../../Assets/Images/LandingPage/economics_logo.png";
import ForeignLangLogo from "../../Assets/Images/LandingPage/foreignlanguage_logo.png";
import { useNavigate } from "react-router-dom";

import CustomButton from 'Components/Commons/CustomButton/CustomButton';

import { ReactComponent as ButtonArrow } from "../../Assets/Images/Button/btn_arrow.svg";

// Reusable Subject Card
const SubjectCard = ({ logo, title, description, backText, bgColor }) => {
    const navigate = useNavigate();

    const handleLearnMore = () => {
        // go to subjects page with hash id (ex: /subjects#civics)
        const targetId = title.toLowerCase().replace(/\s+/g, "-");
        navigate(`/subjects#${targetId}`);
    };

    return (
        <div className='mygrid-col-xl-3 mygrid-col-lg-4 mygrid-col-md-4 mygrid-col-xs-12 subjects_info-box-col'>
            <div className='subjects_info-box' style={{ backgroundColor: bgColor }}>
                <div className='card-inner'>
                    {/* Front */}
                    <div className='subjects_front'>
                        <img src={logo} alt={title} />
                        <h3>{title}</h3>
                        <p>{description}</p>
                    </div>
                    {/* Back */}
                    <div className='subjects_back'>
                        <p>{backText}</p>
                        <CustomButton onClick={handleLearnMore} text="Learn More" />
                    </div>
                </div>
            </div>
        </div>
    );
};


const Mastering = () => {
    const subjects = [
        {
            logo: CivicsLogo,
            title: "Civics",
            description: "Empower students to understand their role in democracy",
            backText: "Explore how government works, why it matters, and how students can make a difference.",
            bgColor: "#ACEBFF"
        },
        {
            logo: ForeignLangLogo,
            title: "Foreign Language",
            description: "Speak the world’s language, one phrase at a time",
            backText: "Master fluency with interactive language games that build vocabulary, strengthen sentence skills, and explore culture.",
            bgColor: "#E8E8E8"
        },
        {
            logo: EnglishLogo,
            title: "English",
            description: "Strengthen literacy through words that matter",
            backText: "Strengthen literacy skills with engaging games focused on vocabulary comprehension.",
            bgColor: "#FFE9D5"
        },
        {
            logo: EconomicsLogo,
            title: "Economics",
            description: "Teach money smarts for real-world success",
            backText: "Master money smarts with interactive economics games that teach concepts, sharpen decision-making, and explore real-world trade.",
            bgColor: "#FFDE5C"
        },
        {
            logo: HistoryLogo,
            title: "History",
            description: "Explore the past to understand the present",
            backText: "Master interactive history games that uncover the past, connect events, and bring stories to life.",
            bgColor: "#84F0CC"
        },
        {
            logo: MathLogo,
            title: "Math",
            description: "Build problem-solvers with numbers that make sense",
            backText: "From basic arithmetic to advanced problem-solving, students build confidence one equation at a time.",
            bgColor: "#FCC"
        },
        {
            logo: ScienceLogo,
            title: "Science",
            description: "Turn curiosity into discovery, one experiment at a time",
            backText: "Level up curiosity with interactive science games that guide students through observation, experimentation, and discovery.",
            bgColor: "#D0F8FF"
        }
    ];

    return (
        <MasteringContainer>
            <div className='mastering_section'>
                <div className='mygrid-container'>
                    <div className='mygrid-row mastering-head_row'>
                        <div className='mygrid-col-md-12 mygrid-col-sm-12'>
                            <div className='mastering-section-head'>
                                <h5 className='subheading'>Mastering</h5>
                                <HeadingWithIcon highlight="Becomes a Strength">
                                    Where Every Subject
                                </HeadingWithIcon>
                                <p>
                                    Subjects Master isn’t just about coverage, it’s about mastery. Our platform is designed to enhance understanding and boost retention across all core subjects. Whether it’s solving equations, analyzing texts, exploring science, or learning a new language, students stay engaged through customized, game-based challenges that make concepts stick.
                                </p>
                                <p className='subtext_mastering'><strong><span className='redfont'>Every subject.</span> Every student. Mastered, <span className='redfont'>one game at a time.</span></strong></p>
                            </div>
                        </div>
                    </div>

                    <div className='mygrid-row subjects_info_wrapper'>
                        {subjects.map((subj, index) => (
                            <SubjectCard key={index} {...subj} />
                        ))}
                    </div>
                </div>
            </div>
        </MasteringContainer>
    );
}

export default Mastering;
